/* ============================================================================
   CY ANNOUNCEMENT NAV
   One small arrow at each edge of the announcement bar for stepping through
   the rotating messages. (The bloom-on-change flashlayer this file once
   injected was retired 2026-08-27 with the rest of the custom effects.)

   Why JavaScript: sections/announcement-bar.liquid is an original theme file
   this project never edits, and its schema has no slider-arrow setting. A
   separate cy-* asset keeps the theme file untouched.

   It drives the theme's OWN slider rather than reimplementing navigation.
   <hdt-slider> exposes goToIndex(index) publicly - the same call the theme uses
   internally - so the arrows stay correct if the slider's internals change, and
   fade mode keeps working because the engine still owns the transition.

   Both buttons are absolutely positioned against the bar at the same inset,
   one per edge, so the message stays optically centred between them instead
   of being pushed off by a grid column.
   ========================================================================== */
(function () {
  'use strict';

  var CHEV = '<svg viewBox="0 0 8 12" aria-hidden="true" focusable="false">' +
    '<path d="M6.5 1L1.5 6l5 5" fill="none" stroke="currentColor" ' +
    'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function build(slider) {
    var nav = document.createElement('div');
    nav.className = 'cy-ann-nav';
    nav.setAttribute('data-cy-ann-nav', '');

    function button(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cy-ann-nav__btn cy-ann-nav__btn--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = CHEV;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        step(slider, dir === 'prev' ? -1 : 1);
      });
      return b;
    }

    nav.appendChild(button('prev', 'Previous announcement'));
    nav.appendChild(button('next', 'Next announcement'));
    return nav;
  }

  function step(slider, delta) {
    var slides = slider.querySelectorAll('.hdt-slider__slide');
    var n = slides.length;
    if (!n || typeof slider.goToIndex !== 'function') return;

    /* In fade mode base.css marks the visible slide .is-selected, so that is
       the source of truth for where we are. Before the slider has selected
       anything the first slide is the one on screen, so 0 is the right start. */
    var i = 0;
    for (var k = 0; k < n; k++) {
      if (slides[k].classList.contains('is-selected')) { i = k; break; }
    }
    slider.goToIndex((i + delta + n) % n);
  }

  function mount() {
    var bars = document.querySelectorAll('.hdt-announcement-bar');
    if (!bars.length) return false;
    var added = 0;
    bars.forEach(function (bar) {
      var slider = bar.querySelector('hdt-slider');
      if (!slider) return;                                          // marquee mode
      if (bar.querySelectorAll('.hdt-slider__slide').length < 2) return;  // nothing to step through
      if (bar.querySelector('[data-cy-ann-nav]')) return;           // never twice
      bar.appendChild(build(slider));
      added++;
    });
    return added > 0;
  }

  function init() {
    /* goToIndex only exists once the element is upgraded */
    var ready = window.customElements && customElements.whenDefined
      ? customElements.whenDefined('hdt-slider')
      : Promise.resolve();
    ready.then(mount).catch(function () { mount(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
